import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-645121de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "out_loader",
  id: "out_loader"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader" })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "txtLoginTitle" }, "Iniciar sesión", -1))
const _hoisted_3 = {
  class: "mailtoTextButton",
  href: "mailto:contacto@vybroo.com"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "¿Necesitas ayuda?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "headerTop ion-no-border" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "mainToolbar ion-no-border" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_button, {
                onClick: _ctx.backPressed,
                alt: "",
                title: "",
                fill: "clear",
                class: "no-ripple"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_img, {
                    id: "backButton",
                    src: "assets/ICONOS/atras.svg"
                  })
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_buttons, {
                slot: "end",
                style: {"width":"100px","margin":"20px 30px 20px 0px"}
              }, {
                default: _withCtx(() => [
                  (_ctx.$route.params.id === 'sonara.red')
                    ? (_openBlock(), _createBlock(_component_ion_img, {
                        key: 0,
                        src: "assets/ICONOS/logo-sonara.png"
                      }))
                    : (_openBlock(), _createBlock(_component_ion_img, {
                        key: 1,
                        src: "assets/ICONOS/vybroo-logo.svg",
                        style: {"float":"right"}
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$route.params.id), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_ion_grid, { class: "mainGrid" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, {
                class: "topRowImage ion-justify-content-center ion-align-items-end",
                style: {"background-image":"url('assets/start/fondo-inicio.jpg')"}
              }),
              _createVNode(_component_ion_row, {
                class: "ion-justify-content-center ion-align-items-center",
                style: {"height":"40vh"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "mainLoginCol"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createElementVNode("form", {
                        ref: "loginForm",
                        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitLoginForm && _ctx.submitLoginForm(...args)), ["prevent"]))
                      }, [
                        _createVNode(_component_ion_input, {
                          placeholder: "Usuario",
                          modelValue: _ctx.mLoginInput,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mLoginInput) = $event)),
                          id: "loginInput",
                          class: "loginInput"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ion_button, {
                          id: "loginButton",
                          type: "submit",
                          fill: "solid",
                          style: {"text-transform":"none","font-weight":"600"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Continuar")
                          ]),
                          _: 1
                        })
                      ], 544)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-justify-content-center ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "mailtoCol" }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_3, [
                        _createVNode(_component_ion_text, { color: "dark" }, {
                          default: _withCtx(() => [
                            _hoisted_4,
                            _createTextVNode(" contacto@vybroo.com")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}